import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getActiveCropId } from 'current/currentSelectors';

import BaseTrigger from 'triggers/BaseTrigger';
import { getCropBasedMessage } from 'util/locale';

const baseString = 'vra-seed-product-selector-trigger';
const classString = classNames({
  [`${baseString}`]: true
});

const SeedProductSelectorTrigger = ({ isVisible = true, onClick }) => {
  const cropId = useSelector(getActiveCropId);
  return isVisible ? (
    <section className={classString}>
      <BaseTrigger
        content={getCropBasedMessage({ key: 'button-text__open-seed-finder', cropId })}
        dataTestId={baseString}
        handler={onClick}
      />
    </section>
  ) : null;
};
SeedProductSelectorTrigger.propTypes = {
  isVisible: propTypes.bool.isRequired,
  onClick: propTypes.func.isRequired
};
export default SeedProductSelectorTrigger;
